export default function getMeasure(fill) {
  if (!fill.measures || fill.measures.length <= 0) return null;

  // For now assume each medication just has one measure.
  // XXX in the future support multiple measures?
  return fill.measures[0];
}
